import { Component, OnInit,ViewEncapsulation, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { GlobalService } from '../global.service';
import { Service } from '../services';

@Component({
  selector: 'app-formcontentchat',
  templateUrl: './formcontentchat.component.html',
  styleUrls: ['./formcontentchat.component.sass'],
  encapsulation:ViewEncapsulation.None
})
export class FormContentChatComponent implements OnInit {

  public name;
  public email;
  public firstname;
  public lastname;
  public preguntaChat;
  public idDPTOChat;
  public message;
  public selectBan;
  public accountType;
  public subscriber;
  public balance;
  private path:string='https://chat3.claropr.com/webapiserver/ECSApp/ChatWidget3/ChatPanel.aspx';
  public isLogged:boolean=false;
  constructor(private services: Service,private global:GlobalService,public matDialogRef:MatDialogRef<FormContentChatComponent>,@Inject(MAT_DIALOG_DATA) public data: any, private router:Router) {
    if(data.selectBan!=undefined){
      this.selectBan=data.selectBan;
    }
    if(data.accountType!=undefined){
      this.accountType=data.accountType;
    }
    if(data.subscriber!=undefined){
      this.subscriber=data.subscriber;
    }
    if(data.balance!=undefined){
      this.balance=data.balance;
    }
  }

  ngOnInit() {
    if(sessionStorage.getItem("session")=="false" || sessionStorage.getItem("session")==null || sessionStorage.getItem("session")=='null'){
      this.name='';
      this.email='';
    }
    else{
      this.name=sessionStorage.getItem("name");
      this.email=atob(sessionStorage.getItem("email"));
      this.isLogged=true;
    }
      
      this.message='';
      this.idDPTOChat=0;
  }
  public close(){;
    this.matDialogRef.close('cancel');
  }
  irChat(){
    if(sessionStorage.getItem("session")!=null){
      this.global.validateSession();
    }
    if(this.validator()){
      if(sessionStorage.getItem("session")=="false" || sessionStorage.getItem("session")==null || sessionStorage.getItem("session")=='null'){
        var url = this.path+'?Email=' + this.email + '&firstname=' + this.firstname + '&lastname=' + this.lastname + '&Question=' + this.message + '&Department='+this.idDPTOChat+'';
        window.open(url, '', 'width=630, height=490,top=100,left=100');  
      } 
      else{
        var url = this.path+'?Email=' + this.email + '&firstname=' + this.firstname + '&lastname=' + this.lastname + '&Question=' + this.message + '&Department='+this.idDPTOChat+ '&BAN='+this.selectBan+ '&subcriptor='+this.subscriber+ '&accountbalance='+this.balance+'&accounttype='+this.accountType+'';
        window.open(url, '', 'width=630, height=490,top=100,left=100');  
      }
    }
  }
  updDpto(dpto){
    this.idDPTOChat=dpto;
  }
  validator(){
    var sw=true;
    if(this.name!=='' && this.name!=undefined){
      var nombre = this.name.split(' ');
      this.firstname = nombre[0];
      this.lastname='';
      if (nombre[1] === '') {
          this.lastname = nombre[2];
      }
      else {
          this.lastname = nombre[1];
      }
      if (nombre[3] !== 'undefined' && nombre[3] !== null && nombre[3] !== undefined) {
          this.lastname = this.lastname + ' ' + nombre[3];
      }
      if (this.lastname === undefined||nombre[1] === undefined ||nombre[1] === 'undefined') {
        this.global.notif('Por favor debe colocar su nombre y apellido.');
        sw=false;
      }
      else {
          if(this.email==''){
            this.global.notif('Debe colocar su correo electronico.');
            sw=false;
          }
          else if(this.global.validarEmail(this.email)==false){
            this.global.notif('Por favor debe colocar un formato de e-mail valido.');
            sw=false;
          }
          else if(this.message==''){
            this.global.notif('Debe colocar una pregunta.');
            sw=false;
          }
          else if(this.idDPTOChat==0||this.idDPTOChat==undefined||this.idDPTOChat==null){
            this.global.notif('Debe seleccionar una departamento para ser atendido.');
            sw=false;
          }
          else{
            this.close();
          }
      }
    }
    else {
      this.global.notif('Debe colocar su nombre y apellido.');
      sw=false;
    }
    return sw;
  }
}